<ng-container *ifScreenSize="screenType.Desktop">
  <fgb-page-header
    [pageTitle]="'rewards.page.title'"
    [showBanner]="true"
    [backButtonLink]="'/'"
    [kidsBanner]="'banners/kids-wallet.jpg'"
  ></fgb-page-header>

  <div class="container wallet-background">
    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
  </div>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <ng-container *notInPopulation="[population.Kids]">
    <fgb-page-header
      [pageTitle]="'nav.wallet'"
      [showBalance]="false"
      [showFooter]="false"
      [showBanner]="false"
      [backButtonLink]="'/'"
    />
  </ng-container>
  <ng-container *inPopulation="[population.Kids]">
    <fgb-page-header
      [pageTitle]="'nav.wallet'"
      [showBalance]="false"
      [showFooter]="false"
      [showBanner]="true"
      [backButtonLink]="'/'"
      [kidsBanner]="'banners/kids-wallet.jpg'"
    />
  </ng-container>
  <div class="barcode-div">
    <fgb-barcode (walletScrollHeight)="walletScrollHeight($event)"></fgb-barcode>
  </div>
</ng-container>

<!-- Wallet -->
<div #walletContainer class="wallet-container">
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="grab-point"><span class="minimize-icon"> </span></div>
  </ng-container>

  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="wallet-redeem-carousel pt-4">
      <div class="container wallet-mobile-padding">
        <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      </div>
    </div>
  </ng-container>

  <!-- Offers -->
  <ng-container *notInPopulation="[population.Kids]">
    <fgb-campaigns-v2-offers-list [showAllOffers]="false"></fgb-campaigns-v2-offers-list>
  </ng-container>

  <div class="container text-center mb-lg-5 claimed-button-div">
    <div class="claimed-button">
      <div class="claimed-button-text">
        <h5 class="claimed-heading mb-1">{{ 'wallet.claimed.heading' | translate }}</h5>
        <div class="font-size-14">{{ 'wallet.claimed.description' | translate }}</div>
      </div>
      <a
        class="font-size-14 claimed-text fw-bold btn btn-quaternary text-black rounded border-0"
        [routerLink]="['/rewards/claimed']"
      >
        {{ 'rewards.wallet.view.claimed' | translate }}
      </a>
    </div>
  </div>
</div>
